const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const { ROUTE_REQUIRE_ENUM } = require('hobbit-base/components/bizs/main/constant');
const engineBaseConfig = require('hobbit-engine-base/modules/config');

const appName = require('../package.json').name;

const { MUST_LOGIN } = ROUTE_REQUIRE_ENUM;

module.exports = mergeObject(engineBaseConfig, {
  runtime: process.env.VUE_APP_RUNTIME,
  site: {
    publicPath: `https://s.vipkidstatic.com/fe-static/${appName}/prod/${process.env.VUE_APP_DRONE || 'default'}/`,
    noLangPath: true,
  },
  theme: true,
  user: {
    signupSourceKey: 'vkSignupSource',
    regionCodeKey: 'regionCode',
    // === 完成注册之后跳转的页面 ===
    registrationTransferUrl: null,
  },
  log: {
    appName,
  },
  routes: {
    // #region 官网页面
    home: {
      index: 1,
      path: '/([a-z]{2}-[a-z]{2})?/',
      view: '/home/home.vue',
      mview: '/home/m_home.vue',
      preloads: ['signin', 'signup'],
    },
    intro_howitworks: {
      index: 2,
      path: '/([a-z]{2}-[a-z]{2})?/how-it-works/',
      view: '/intro/howitworks/howitworks.vue',
      mview: '/intro/howitworks/m_howitworks.vue',
    },
    intro_ourteachers: {
      index: 3,
      path: '/([a-z]{2}-[a-z]{2})?/our-teachers/',
      view: '/intro/ourteachers/ourteachers.vue',
      mview: '/intro/ourteachers/m_ourteachers.vue',
    },
    intro_purchase: {
      index: 4,
      path: '/([a-z]{2}-[a-z]{2})?/pricing/',
      view: '/intro/purchase/purchase.vue',
      mview: '/intro/purchase/m_purchase.vue',
    },
    // #endregion
    // #region goods 商品相关
    goodsDetail: {
      index: 746,
      path: '/([a-z]{2}-[a-z]{2})?/goods/goodsdetail/',
      view: '/goods/goodsDetail/goodsDetail.vue',
    },
    // goodsList: {
    //   index: 745,
    //   path: '/([a-z]{2}-[a-z]{2})?/goods/goodslist/',
    //   view: '/goods/goodsList/goodsList.vue',
    //   mview: '/goods/goodsList/m_goodsList.vue',
    // },
    // #endregion
    // #region 订单与支付相关
    // order: {
    //   index: 40,
    //   path: '/([a-z]{2}-[a-z]{2})?/purchase/order/',
    //   view: '/ucenter/purchase/order/orderList.vue',
    //   mview: '/ucenter/purchase/order/m_orderList.vue',
    //   meta: {
    //     require: MUST_LOGIN,
    //   },
    // },
    // classhourdetail: {
    //   index: 46,
    //   path: '/([a-z]{2}-[a-z]{2})?/order/classhourdetail/',
    //   view: '/ucenter/course/classhourdetail/classhourdetail.vue',
    //   meta: {
    //     require: MUST_LOGIN,
    //   },
    // },
    order_detail: {
      index: 41,
      path: '/([a-z]{2}-[a-z]{2})?/purchase/order/detail/',
      view: '/ucenter/purchase/orderDetail/orderDetail.vue',
      mview: '/ucenter/purchase/orderDetail/m_orderDetail.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    // order_checkout: {
    //   index: 42,
    //   path: '/([a-z]{2}-[a-z]{2})?/purchase/order/checkout/',
    //   view: '/ucenter/purchase/orderCheckout/orderCheckout.vue',
    //   mview: '/ucenter/purchase/orderCheckout/m_orderCheckout.vue',
    //   meta: {
    //     require: MUST_LOGIN,
    //   },
    // },
    order_pay: {
      index: 43,
      path: '/([a-z]{2}-[a-z]{2})?/purchase/order/pay/',
      view: '/ucenter/purchase/orderPay/orderPay.vue',
      mview: '/ucenter/purchase/orderPay/m_orderPay.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    bill: {
      index: 44,
      path: '/([a-z]{2}-[a-z]{2})?/bill/',
      view: '/ucenter/bill/bill.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    // #endregion
    // #region 账户信息相关
    signup: {
      index: 1010,
      path: '/([a-z]{2}-[a-z]{2})?/signup/',
      view: '/user/signup/signup.vue',
      preloads: ['signin'],
    },
    signin: {
      index: 1020,
      path: '/([a-z]{2}-[a-z]{2})?/signin/',
      view: '/user/signin/signin.vue',
      preloads: ['signup'],
    },
    // #endregion
    // #region 优惠券相关
    couponbox: {
      index: 50,
      path: '/([a-z]{2}-[a-z]{2})?/ucenter/couponbox/',
      view: '/ucenter/coupon/couponbox.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    // courseoverview: {
    //   index: 60,
    //   path: '/([a-z]{2}-[a-z]{2})?/ucenter/course/(overview/)?',
    //   view: '/ucenter/course/overview/overview.vue',
    //   meta: {
    //     require: MUST_LOGIN,
    //   },
    // },
    exchange: {
      index: 70,
      path: '/([a-z]{2}-[a-z]{2})?/ucenter/exchange/',
      view: '/ucenter/exchange/exchange.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    // #endregion
    // #region 辅助页面
    preload: {
      index: -10,
      path: '/([a-z]{2}-[a-z]{2})?/preload/',
      view: '/service/preload/preload.vue',
      pv: false,
    },
    // #endregion
    // #region 活动页面
    thankful: {
      index: 601,
      path: '/([a-z]{2}-[a-z]{2})?/thankful/',
      view: '/promotion/thankful/m-thankful.vue',
    },
    transform: {
      index: 603,
      path: '/([a-z]{2}-[a-z]{2})?/transform/',
      view: '/promotion/transform/m-transform.vue',
    },
    learningpartner: {
      index: 604,
      path: '/([a-z]{2}-[a-z]{2})?/learningpartner/',
      view: '/promotion/learningpartner/m-learningpartner.vue',
    },
    referral: {
      index: 600,
      path: '/([a-z]{2}-[a-z]{2})?/referral/',
      view: '/promotion/referral/referral.vue',
      mview: '/promotion/referral/m-referral.vue',
    },
    error404: {
      index: 404,
      path: '*',
      view: '/service/error404/error404.vue',
      meta: {
        agentAuth: ['*'],
      },
    },
    // #endregion
  },
  abtest: {},
  // 业务自定义配置信息
  custom: {
    // === 禁用IM的路由 ===
    disableIMRoutes: {
      pc: [
        'signup',
        'signin',
        'preload',
        'bill',
        'order',
        'order_detail',
        'order_checkout',
        'order_pay',
        'trialres',
        'thankful',
        'classfeedback',
        'landingpage',
        'classroom',
        'replays',
      ],
      m: [
        'signup',
        'signin',
        'preload',
        'bill',
        'order',
        'order_detail',
        'order_checkout',
        'order_pay',
        'trialres',
        'thankful',
        'booktrialclass',
        'trialteacherlist',
        'bookmajorclass',
        'majortsteachers',
        'majortimeslotdetail',
        'majorentry',
        'majorteachers',
        'majortdetail',
        'majorteachertimeslot',
        'majorteachersearch',
        'classfeedback',
        'landingpage',
        'replays',
      ],
    },
    facebook: {
      SDK_URL: 'https://connect.facebook.net/en_US/sdk.js',
      appId: '861697761215854',
    },
    google: {
      SDK_URL: 'https://apis.google.com/js/platform.js',
      client_id: '676572178122-sabukf1gaooja9cia7h13gs990ttr8l3.apps.googleusercontent.com',
    },
    globalShuntConfig: {
      // 全球站分流需要去除的国家码
      exclude: ['cn'],
      // 全球站分流需要添加的国家码
      include: {
        kr: {
          code: 'kr', name: 'South Korea (대한민국)', dialCode: 82, example: '82 10720 78764',
        },
        sa: {
          code: 'sa', name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', dialCode: 966, example: '051 234 5678',
        },
        tw: {
          code: 'tw', name: 'Taiwan 台湾', dialCode: 886, example: '886 051 234 5678',
        },
      },
      globalShunt: {
        cn: {
          action: 'TOPBAR', // 'TOPBAR,JUMP'
          selectedJump: false,
        },
        sa: {
          action: 'JUMP',
          selectedJump: true,
          url: 'https://ksa.vipkid.com/?channel=SA0000S',
        },
        kr: {
          action: 'TOPBAR',
          selectedJump: true,
          url: 'https://kr.vipkid.com/?from=KR000c8',
        },
        vn: {
          action: 'JUMP',
          selectedJump: true,
          url: 'https://kid.topica.edu.vn/?channel=VN000k3',
        },
        tw: {
          action: 'JUMP',
          selectedJump: true,
          url: 'https://tw.vipkid.com/?channel=TW000cM',
        },
        jp: {
          action: 'JUMP',
          selectedJump: true,
          url: 'https://jp.vipkid.com/?channel=JP000c5',
        },
      },
    },
    cmsApiBase: '/rest/gw/mgt/api/cms',
    currencyMaps: {
      USD: '$',
      HKD: 'HK$',
      CNY: '￥',
    },
    airwallex: {
      fontUrl: 'https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2', // airwallex 支付平台字体url
      sdkUrl: 'https://checkout.airwallex.com/assets/elements.bundle.min.js',
    },
    mPayPageSupportPayMehod: [5, 6, 7, 9], // 支付页支持的支付方式 // 5 信用卡 6 微信 7 支付宝 手机端暂不支持 paypal
    // cms key 集合
    cmsKeyMaps: {
      privacyKey: 'KUWJ6IWHQ9YDWLHM', // cms 隐私政策 key
      productContractKeyPrefix: 'GLOBAL_PRODUCT_CONTRACT_', // cms 商品合同Key 前缀
      studentLevelQuestionsKeyPrefix: 'L4WOKKAR7EE9O1VS_', // 定级问卷CMSkey前缀
    },
    signupSourceChannels: {
      pc: {
        home_headerSignup: 'HK000ZL',
        home_headerTrial: 'HK000ZG',
        home_banner: 'HK000ZV',
        home_footer: 'HK000ZC',
        intro_howitworks_headerSignup: 'HK000Za',
        intro_howitworks_headerTrial: 'HK000Zi',
        intro_howitworks_part1: 'HK000Zj',
        intro_howitworks_part4: 'HK000ZB',
        intro_howitworks_footer: 'HK000Zw',
        intro_ourteachers_headerSignup: 'HK000ZA',
        intro_ourteachers_headerTrial: 'HK000Zm',
        intro_ourteachers_footer: 'HK000ZM',
        referral_headerSignup: 'HK000zg',
        referral_footer: 'HK000ZW',
        downloads_footer: 'HK000Zg',
        im: 'HK000Zf',
        faqsignup: 'HK000Zb',
        faqlevel: 'HK000Zb',
        signin: 'HK000ZU',
      },
      m: {
        home_headerSignup: 'HK000Zz',
        home_footer: 'HK000Z6',
        intro_howitworks_headerSignup: 'HK000Zk',
        intro_howitworks_part1: 'HK000Z3',
        intro_howitworks_part4: 'HK000Zx',
        intro_howitworks_footer: 'HK000Zd',
        intro_ourteachers_headerSignup: 'HK000Zn',
        intro_ourteachers_footer: 'HK000Zu',
        referral_headerSignup: 'HK000z7',
        referral_footer: 'HK000ZX',
        im: 'HK000ZJ',
        faqsignup: 'HK000Z7',
        faqlevel: 'HK000Z7',
        signin: 'HK000Z5',
      },
    },
    openToInlandSignup: true, // 是否放开86注册
    openToInlandLogin: true, // 是否放开86登录
    maxChilds: 1,
  },
});
